import React, { useState, useContext, useEffect } from "react";

const BrandingContext = React.createContext();

export function useBranding() {
  return useContext(BrandingContext);
}

export function BrandingProvider({ children }) {
  const [branding, setBranding] = useState("Vision Insights");

  useEffect(() => {
    const baseURL = window.location.href;
    // const baseURL = "https://playfly-dev.visioninsights.net/signin";
    if (baseURL.includes("playfly")) setBranding("Playfly Sports");
  }, []);
  const value = {
    branding: {
      title: branding,
      className: branding.split(" ")[0].toLowerCase(),
    },
  };

  return (
    <BrandingContext.Provider value={value}>
      {children}
    </BrandingContext.Provider>
  );
}
